<script setup lang="ts">
    import { computed } from 'vue';
    import { useRoute } from 'vue-router';

    import AuthLayout from './layouts/AuthLayout.vue';
    import DashboardLayout from './layouts/DashboardLayout.vue';
    import DefaultLayout from './layouts/DefaultLayout.vue';
    import LivestreamForm from './layouts/LivestreamForm.vue';

    const route = useRoute();

    const layout = computed(() => {
        return (
            route.meta.layout || AuthLayout || DashboardLayout || DefaultLayout || LivestreamForm
        );
    });
</script>

<template>
    <Toast />
    <div id="app">
        <component :is="layout">
            <RouterView />
        </component>
        <div id="overlay-layer"></div>
    </div>
</template>

<style scoped>
    #app {
        position: relative;
    }
    #overlay-layer {
        position: absolute;
        inset: 0;
        pointer-events: none;
        z-index: 9999;
    }
</style>
